import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReqService } from '@core/services';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MbProgressBarModule, MoebiusUIModule, MbIconRegistry } from '@am/moebius';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { hotelsIcons } from './icons';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [CommonModule, RouterModule, MbProgressBarModule, MoebiusUIModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppComponent implements OnInit {
  public showExpertsCommunications: boolean;
  public channel: string;

  constructor(
    private router: Router,
    private reqService: ReqService,
    private mbIconRegistry: MbIconRegistry,
  ) {
    this.router.initialNavigation();
    for (const icon of hotelsIcons) {
      this.mbIconRegistry.addSvgIconDefinition(icon);
    }
  }

  ngOnInit() {
    this.channel = this.reqService.getChannel();
    const page = this.reqService.getPage();
    const light = this.reqService.getLight();

    const isHotelPage = ['detail', 'tickets'].includes(page);
    const isLight = !light || light === 'gtm';

    this.showExpertsCommunications = isHotelPage && isLight;
  }
}
